<template>
  <v-card class="pa-4 card" :disabled="noteLoading">
    <div
      style="position: absolute; left: 48%; z-index: 3; top: 45%"
      v-if="noteLoading"
    >
      <v-progress-circular size="30" indeterminate></v-progress-circular>
    </div>

    <h3 class="text-center my-2">Últimas atualizações</h3>

    <v-card-text class="py-0">
      <div class="pa-4 text-center" v-if="notes.length == 0">
        Ainda não há nenhuma nota de atualização registrada...
      </div>
      <v-timeline align-top dense v-else>
        <v-timeline-item
          :color="i % 2 == 0 ? 'primary' : 'secondary'"
          small
          v-for="(note, i) in notes"
          :key="note.id"
        >
          <v-row class="pt-1">
            <v-col cols="3">
              <strong>
                {{ formatDate(note.patchDate) }}
              </strong>
            </v-col>
            <v-col>
              <strong>{{ note.title }}</strong>
              <div class="text-caption">{{ note.note }}</div>
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import ApiService from '../../services/ApiService'
import FormatDate from '../../Utils/FormatDate'

export default {
  name: 'PatchNotesModal',

  props: {
    registerNote: Boolean,
  },

  created() {
    this.getNotes()

    if (this.registerNote) {
      this.user = JSON.parse(localStorage.getItem('user'))
      this.setNote()
    }
  },

  data() {
    return {
      apiService: new ApiService(),
      noteLoading: false,
      notes: [],
    }
  },

  methods: {
    setNote() {
      this.apiService.post(`patchNote/user/add/${this.user.id}`)
    },

    getNotes() {
      this.noteLoading = true

      let url = 'patchNote/list'

      if (this.registerNote) {
        url = 'patchNote/list/lastten'
      }

      this.apiService
        .get(url)
        .then((response) => {
          this.notes = response.content
          this.noteLoading = false
        })
        .catch(() => {
          this.noteLoading = false
        })
    },

    formatDate(date) {
      return FormatDate.dateTime(date)
    },
  },
}
</script>

<style scoped>
.card {
  border-radius: 10px !important;
}
</style>
